import type { SettingsSource } from '../models/settings-hub.model';

import { field } from './settings-builders';
export const SECURITY_SUBCATEGORY: SettingsSource = {
    id: 'security',
    cards: [
        {
            id: 'operator-access',
            settings: [
                field.toggle('users.enable_user_logout', 'SETTINGS.SETTINGS.ENABLE_USER_LOGOUT'),
                field.toggle('users.enable_user_switch', 'SETTINGS.SETTINGS.ENABLE_USER_SWITCH'),
                field.toggle('users.ask_the_operator_open_app', 'SETTINGS.SETTINGS.ENABLE_USER_PIN_OPEN_APP'),
                field.toggle('users.enable_user_logout_pin', 'SETTINGS.SETTINGS.ENABLE_USER_LOGOUT_PIN'),
                field.toggle('users.enable_user_login_from_badge', 'SETTINGS.SETTINGS.ENABLE_USER_LOGIN_FROM_BADGE')
            ]
        }
    ]
};

export const NOTIFICATIONS_SUBCATEGORY: SettingsSource = {
    id: 'notifications',
    cards: [
        {
            id: 'operational-notifications',
            settings: [
                field.toggle('cashregister.disable_external_sales_notification', 'SETTINGS.SETTINGS.DISABLE_EXTERNAL_SALES_NOTIFICATION'),
                field.toggle('cashregister.disable_external_bookings_notification', 'SETTINGS.SETTINGS.DISABLE_EXTERNAL_BOOKINGS_NOTIFICATION'),
                field.toggle('dashboard.disable_einvoice_status', 'SETTINGS.SETTINGS.DISABLE_EINVOICE_STATUS'),
                field.toggle('e_invoice.notify_errors', 'SETTINGS.SETTINGS.E_INVOICE_NOTIFY_ERRORS'),
                field.number('dashboard.einvoice_quantity_warning', 'SETTINGS.SETTINGS.EINVOICE_QUANTITY_WARNING')
            ]
        }
    ]
};
